import { RefObject, createContext, useContext } from 'react';

type CardContextContent = {
    cardRef: RefObject<HTMLDivElement | null>;
    setCardNode: (node: HTMLDivElement | null) => void;
    onRemove?: (item: Material) => void;
};

const CardContext = createContext<CardContextContent>({
    cardRef: { current: null },
    setCardNode: () => {}
});

export const useCardContext = () => useContext(CardContext);

export default CardContext;
